import _ from 'lodash';

import PutSnippetBase from './put_snippet_base';

export default class UpdateSnippet extends PutSnippetBase {
  runAction(attrs) {
    this.context.gateways.snippet.update(attrs.id, _.omit(attrs, 'id'));
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/knowledge_base/update_snippet.js